/* @flow */
import CreateEventCostEducation from 'payments/components/CreateEventCostEducation.jsx';
import cx from 'classnames';
import Button from 'components/Button.jsx';
import Glyph from 'components/Glyph.jsx';
import Hovercard from 'components/Hovercard.jsx';
import LayerTrigger from 'components/LayerTrigger.jsx';
import NumberInput from 'components/NumberInput.jsx';
import React, { Component, PropTypes } from 'react';

import './styles/AmountInput.scss';

class HelpHovercard extends Component {
  render() {
    return (
      <Hovercard {...this.props} className="AmountInput-hovercard">
        <CreateEventCostEducation />
      </Hovercard>
    );
  }
}

export default class AmountInput extends Component {
  static propTypes = {
    customHelpClickHandler: PropTypes.func,
    inputClassName: PropTypes.string,
  }

  state = {
    focused: false,
  };

  getInputNode() {
    return this.refs.input.getInputNode();
  }

  handleOnFocus = () => {
    this.setState({ focused: true });
  }

  renderHelp() {
    const button = (
      <Button
        color="eclipse"
        level="text"
        className="AmountInput-help"
        eventElementName="AmountInput-help">
        <Glyph name="help" size="small" solo />
      </Button>
    );

    if (this.props.customHelpClickHandler) {
      return button;
    }

    return (
      <LayerTrigger trigger="click" placement="top" layer={<HelpHovercard />} delayShow={400}>
        {button}
      </LayerTrigger>
    );
  }

  render() {
    return (
      <div>
        <NumberInput
          {...this.props}
          className={cx('AmountInput', this.props.className)}
          inputClassName={cx('AmountInput-input', this.props.inputClassName)}
          ref="input"
          glyph="dollar-circle"
          append={this.state.focused && this.renderHelp()}
          onFocus={this.handleOnFocus}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/AmountInput.jsx